import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Images = styled('div')<{ imageCount: number }>(
    ({ theme: { spacing, mq, borderRadius }, imageCount }) => css`
        display: flex;
        overflow: hidden;
        margin-bottom: ${spacing['24px']};

        ${mq.medium} {
            margin-bottom: 0;
        }

        img {
            border-radius: ${borderRadius['4px']};
            display: none;
            object-fit: cover;
            max-height: 166px;
            flex-grow: ${imageCount === 1 ? 0 : 1};
            width: ${imageCount === 1 ? 'unset' : '48%'};
            margin-right: ${spacing['8px']};

            &:nth-of-type(1) {
                display: block;
                ${imageCount === 1 ? 'margin-right: 0;' : ''}
            }

            &:nth-of-type(2) {
                display: block;
                ${imageCount < 3 ? 'margin-right: 0;' : ''}
            }

            &:nth-of-type(3) {
                ${imageCount >= 3 ? 'margin-right: 0;' : ''}
            }

            ${mq.small} {
                flex-grow: ${imageCount <= 2 ? 0 : 1};
                width: ${imageCount <= 2 ? 'unset' : '32.5%'};

                &:nth-of-type(2) {
                    display: block;
                }
            }

            ${mq.medium} {
                &:nth-of-type(3) {
                    display: block;
                }

                &:nth-of-type(2) {
                }

                &:first-of-type {
                }
            }

            ${mq.large} {
                width: ${imageCount <= 2 ? 'unset' : '32.2%'};
            }

            ${mq.extraLarge} {
                width: ${imageCount <= 2 ? 'unset' : '50%'};

                &:nth-of-type(3) {
                    display: block;
                }

                &:nth-of-type(2) {
                }

                &:first-of-type {
                }
            }
        }
    `
);
